import { Pipe, PipeTransform } from '@angular/core';
import { Weekday } from '@app/shared/models/shared.models';

@Pipe({
	name: 'weekDayLabel'
})
export class WeekDayLabelPipe implements PipeTransform {

	private readonly map = {
		[Weekday.Monday]: $localize`:@@common.monday:Monday`,
		[Weekday.Tuesday]: $localize`:@@common.tuesday:Tuesday`,
		[Weekday.Wednesday]: $localize`:@@common.wednesday:Wednesday`,
		[Weekday.Thursday]: $localize`:@@common.thursday:Thursday`,
		[Weekday.Friday]: $localize`:@@common.friday:Friday`,
		[Weekday.Saturday]: $localize`:@@common.saturday:Saturday`,
		[Weekday.Sunday]: $localize`:@@common.sunday:Sunday`
	};

	transform (weekDay: number): string {
		return this.map[weekDay] || weekDay;
	}
}